import { styled } from '@mui/material/styles';
import { Box, Typography, Button } from '@mui/material';

export const FormPageContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Consider theme.shadows
  padding: theme.spacing(4),
  width: '88%',
  minWidth: '500px',
  marginBottom: theme.spacing(3),
  transition: 'all 0.3s ease',
}));

export const FormHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary, // Adjusted for theme
  textAlign: 'center',
  marginBottom: theme.spacing(3),
}));

export const FormSubHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary, // Adjusted for theme
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(2.5),
  borderBottom: `1px solid ${theme.palette.divider}`,
  paddingBottom: theme.spacing(1.5),
}));

export const StyledForm = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'component',
})({
    display: 'flex',
    flexDirection: 'column',
    gap: theme => theme.spacing(2.5), // Add gap between form elements
});


export const SubmitButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(3),
  padding: theme.spacing(1.5, 2.5),
  fontWeight: 600,
  background: theme.palette.secondary.main,
}));